import React from 'react';
import PropTypes from "prop-types";
import {NavLink} from "react-router-dom";
import {isInternalLink} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import './CareersFooter.scss';

const CareersFooter = ({links}) => {

    // Split Links into 2 Columns
    const firstColumnOfLinks = links.slice(0, (Math.ceil(links.length / 2)));
    const secondColumnOfLinks = links.slice((Math.ceil(links.length / 2)));

    // Generate the Menu Spacers
    const firstColumnSpacers = [];
    const secondColumnSpacers = [];

    if (firstColumnOfLinks.length > secondColumnOfLinks.length) {
        const secondColumnSpacersToAdd = firstColumnOfLinks.length - secondColumnOfLinks.length;
        for (let i = 0; i < secondColumnSpacersToAdd; i+=1) {
            secondColumnSpacers.push(<span key={`careersFooterColumn__secondary_spacer_${i}`}>&nbsp;</span>)
        }
    }
    else if (secondColumnOfLinks.length > firstColumnOfLinks.length) {
        const firstColumnSpacersToAdd = secondColumnOfLinks.length - firstColumnOfLinks.length;
        for (let i = 0; i < firstColumnSpacersToAdd; i+=1) {
            firstColumnSpacers.push(<span key={`careersFooterColumn__primary_spacer_${i}`}>&nbsp;</span>)
        }
    }

    return (
        <React.Fragment>
            <footer className="careersFooter">
                <div className="container careersFooter__container">

                    <div className="careersFooter__wrapper">
                        <div className="careersFooterColumn">
                            <div className="careersFooterColumn__row">
                                <img src="/public/images/careers/Careers_Footer_Logo.png" alt=""/>
                            </div>
                        </div>

                        <div className="careersFooterColumn careersFooterColumn--links">

                            <div className="careersFooterColumn__links">
                                {firstColumnOfLinks.map(link => (
                                    isInternalLink(link.url.path) && link.url.path !== '/website-issue' ? (
                                        <NavLink to={link.url.path}>{link.label}</NavLink>
                                    ) : (
                                        <a onClick={() => trackEventByUrl(link.url.path, link.label)}
                                           href={link.url.path}>{link.label}</a>
                                    )
                                ))}
                                {firstColumnSpacers && firstColumnSpacers.length ? firstColumnSpacers.map(spacer => spacer) : null}
                            </div>

                            <div className="careersFooterColumn__links">
                                {secondColumnOfLinks.map(link => (
                                    isInternalLink(link.url.path) && link.url.path !== '/website-issue' ? (
                                        <NavLink to={link.url.path}>{link.label}</NavLink>
                                    ) : (
                                        <a onClick={() => trackEventByUrl(link.url.path, link.label)}
                                           href={link.url.path}>{link.label}</a>
                                    )
                                ))}
                                {secondColumnSpacers && secondColumnSpacers.length ? secondColumnSpacers.map(spacer => spacer) : null}
                            </div>
                        </div>
                    </div>


                    <p className="copyright">© 2025 MarketAxess Holdings Inc.</p>

                </div>
                <div className="security-container">
                    <div className="security-container-inner">
                        <p>Please beware of malicious websites and applications impersonating MarketAxess: MarketAxess
                            does not service retail customers, nor does it request or receive online money transfers.
                            Always verify official channels, MarketAxess takes no responsibility for such third-party
                            actions.</p>
                    </div>
                </div>

            </footer>
        </React.Fragment>
    );
}

CareersFooter.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    links: PropTypes.array
};

CareersFooter.defaultProps = {
    links: []
};

export default CareersFooter;



// WEBPACK FOOTER //
// ./frontend/components/Footer/CareersFooter.jsx